/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $AnniversaryListing = {
    properties: {
        anniversaries: {
    type: 'array',
    contains: {
        type: 'ListedAnniversary',
    },
    isRequired: true,
},
    },
};